import { formatTransactionDescription } from 'mmfintech-backend-api'
import type { TransactionViewPortal } from 'mmfintech-backend-api/types'

import { applyCurrencyDisplayOverrides } from './currencyDisplay'

/**
 * Display-safe wrapper around the backend `formatTransactionDescription`.
 *
 * The backend builds some descriptions (e.g. Exchange) from raw currency codes
 * like `TKB.ERC20`, which must be shown to the user as `TKB`. This applies the
 * presentation-only currency overrides to the already-translated string so every
 * transaction-list/details consumer renders consistent labels.
 */
export const formatTransactionDescriptionForDisplay = (data: TransactionViewPortal): string => {
  const formattedDescription = formatTransactionDescription(data)
  return applyCurrencyDisplayOverrides(formattedDescription)
}
